import { Component, OnInit, Input, ViewChild, ElementRef, Inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { CustomDeviceDetectorService } from '../../services/CustomDeviceDetectorService';
import { isPlatformServer } from '@angular/common';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

@Component({
  selector: 'app-hero-slider-parallax',
  templateUrl: './hero-slider-parallax.component.html',
  styleUrls: ['./hero-slider-parallax.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeroSliderParallaxComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  @ViewChild('HeroSlider', { static : false}) swiperSlider!: ElementRef;
  dynamicClass: string;
  jssStylingService: JssStylingService;
  devicedetectorService: CustomDeviceDetectorService;
  isMobile: boolean;
  swiper: Swiper;
  _isPlatformServer: boolean = false;
  bubbleClass: string = " ";

  constructor(jssStylingService: JssStylingService, devicedetectorService: CustomDeviceDetectorService,@Inject(PLATFORM_ID) public readonly platformId: string,) { 
    this.jssStylingService = jssStylingService;
    this.devicedetectorService = devicedetectorService;
    platformId 
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('heroSliderParallax component initialized with component data', this.rendering);
    this._isPlatformServer = isPlatformServer(this.platformId);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    var fields = (this.rendering.fields as any);
    this.bubbleClass = fields.WantBubbles['value'] ? (fields.OnlyBlueBubbles['value'] ? "hero-slider-bubbles-only-blue" : "hero-slider-bubbles") : " ";
    this.isMobile = this.devicedetectorService.isMobile();
    
    this.bubbleClass = this.isMobile ? (fields.WantBubbles['value'] ? (fields.OnlyBlueBubbles['value'] ? "hero-slider-bubbles-mobile-only-blue" : "hero-slider-bubbles-mobile") : " "): this.bubbleClass;
    if(!this._isPlatformServer){
      this.swiper = new Swiper(".eq-swiper-slider", {
        slidesPerView: "auto",
        autoplay: parseFloat((this.rendering.fields?.TimeRotation as any)?.value) && parseFloat((this.rendering.fields?.TimeRotation as any)?.value) > 0 ?
          {
            delay: parseFloat((this.rendering.fields?.TimeRotation as any)?.value)*1000,
          } : false ,
        speed:1200,
        freeMode: true,
        centeredSlides: false,
        spaceBetween: 32,
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        modules:[Pagination, Autoplay]
      });
    }
  }
}